import { useEffect, useState } from "react";
import Helper from "../Helper";

const useUIHook = () => {
    const [activeSidebarKey, setActiveSidebarKey] = useState("portal");
    const [collapseSidebar, setCollapseSidebar] = useState(false);
    const [showNotificationsDrawer, setShowNotificationsDrawer] = useState(false);
    const [addTeamToProjectModal, setAddTeamToProjectModal] = useState<"member" | "vendor" | null>(null);

    useEffect(() => {
        const cookie = Helper.getCookie("userPreferences");
        let collapseSidebar: boolean = false;
        if (cookie) {
            const userPreferences = JSON.parse(cookie);
            collapseSidebar = userPreferences?.collapseSidebar;
        }

        if (collapseSidebar === undefined || collapseSidebar === null) {
            return;
        }

        if (!collapseSidebar && window.innerWidth < 992) {
            setCollapseSidebar(true);
            return;
        }
        setCollapseSidebar(collapseSidebar);
    }, []);

    return {
        activeSidebarKey,
        setActiveSidebarKey,
        collapseSidebar,
        setCollapseSidebar,
        showNotificationsDrawer,
        setShowNotificationsDrawer,
        addTeamToProjectModal,
        setAddTeamToProjectModal,
    };
};

export default useUIHook;
